import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoginFacadeService } from '../../../../data-access/facades/login/login-facade.service';

@Injectable({ providedIn: 'root' })
export class LoginStateService {
  private readonly loginFacade = inject(LoginFacadeService);

  readonly isLoggedIn = toSignal(this.loginFacade.isLoggedIn$, {
    initialValue: false
  });
}
